import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs/operators';
import { RequestState } from '../../../shared/definitions/request-state.enum';
import * as AuthenticationStoreActions from '../../authentication/store/authentication-store.actions';
import { TaxonomyService } from '../services/taxonomy.service';
import * as TaxonomyStoreActions from './taxonomy-store.actions';
import * as TaxonomyStoreSelectors from './taxonomy-store.selectors';

@Injectable()
export class TaxonomyStoreEffects {
  private readonly _actions = inject(Actions);
  private readonly _store = inject(Store);
  private readonly _taxonomyService = inject(TaxonomyService);

  taxonomyTermsRequested$ = createEffect(() =>
    this._actions.pipe(
      ofType(TaxonomyStoreActions.ActionTypes.RequestTaxonomyTerms),
      concatLatestFrom(() =>
        this._store.select(
          TaxonomyStoreSelectors.selectTaxonomyTermsRequestState,
        ),
      ),
      filter(([_, requestState]) => requestState === RequestState.Initial),
      map(() => TaxonomyStoreActions.fetchTaxonomyTerms()),
    ),
  );

  taxonomyTermsFetched$ = createEffect(() =>
    this._actions.pipe(
      ofType(TaxonomyStoreActions.ActionTypes.FetchTaxonomyTerms),
      switchMap(() => this._taxonomyService.fetchAllTaxonomyTerms()),
    ),
  );

  resetTaxonomyStore$ = createEffect(() =>
    this._actions.pipe(
      ofType(AuthenticationStoreActions.ActionType.LogoutSucceeded),
      map(() => TaxonomyStoreActions.resetTaxonomyStore()),
    ),
  );
}
